<div class="product-silo" data-test="product-silo">
  <ng-container *ngIf="(quantityExceededOrder$ | async) === true && exact.value">
    <div class="product-silo__error notification notification-error text--input-small" data-test="product-silo__quantity-exceeded-error">
      <mat-icon>error</mat-icon>
      {{ 'product.wizard.silo.order-quantity-exceeded' | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="(lessThanQuantity$ | async) === true && exact.value && entries.dirty">
    <div class="product-silo__error notification notification-error text--input-small" data-test="product-silo__less-than-quantity-error">
      <mat-icon>error</mat-icon>
      {{ 'product.wizard.silo.less-than-order-quantity' | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="locationSilos$ | async as silos">
    <p *ngIf="silos?.length > 0" class="product-silo__description">
      {{ 'product.wizard.silo.description' | translate }}
    </p>

    <div class="product-silo__content" *ngIf="silos?.length > 0">
      <div class="flex--row flex--align-center spacing--margin-half-top">
        <div class="flex__child">
          <div class="text--label">{{ 'product.wizard.silo.amount' | translate }}</div>
          <div *ngIf="orderingInformation">
            <ng-container *ngIf="quantity$ | async as quantity">
              {{ quantity }}
            </ng-container>
            {{ 'unit.' + orderingInformation?.orderUnit | translate }}
          </div>
        </div>
        <div class="flex__child" *ngIf="this.exact.value === true && quantityInTheLine">
          <div class="text--label">
            {{ 'product.wizard.silo.not-distributed-amount' | translate }}
          </div>
          <div *ngIf="orderingInformation">
            {{ quantityInTheLine }}
            {{ 'unit.' + orderingInformation?.orderUnit | translate }}
          </div>
        </div>

        <mat-slide-toggle
          [formControl]="exact"
          color="primary"
          class="spacing--margin-top spacing--margin-half-bottom"
          data-test="product-silo__exact"
          (change)="changeExact($event)"
        >
          {{ 'product.wizard.silo.exact' | translate }}
        </mat-slide-toggle>
      </div>

      <div>
        <div class="border-top spacing--margin-top" *ngIf="this.exact.value === true">
          <div
            class="product-silo__description notification notification-description text--input-small"
            data-test="product-silo__less-than-quantity-description"
          >
            <mat-icon>information</mat-icon>
            {{
              (this.isExactWeightShipTo
                ? 'product.wizard.silo.silo-distribution-information-exact-with-toggle'
                : 'product.wizard.silo.silo-distribution-information-exact'
              ) | translate
            }}
          </div>
          <ng-container *ngFor="let entry of entries.controls; let index = index">
            <mat-card
              appearance="outlined"
              class="spacing--margin-vertical spacing--margin-half-horizontal mat-elevation-z1"
              *ngIf="getFormGroup(entry) as group"
            >
              <mat-card-header>
                <p class="text--bold spacing--margin-none-top spacing--margin-half-bottom">
                  {{ 'product.wizard.silo.choose-silo' | translate }}
                </p>
              </mat-card-header>

              <mat-card-content>
                <div [formGroup]="group" class="product-silo__card flex--row" data-test="product-silo__silo-row">
                  <mat-form-field appearance="outline" class="product-silo__card-input mat-form-field__no-spacing flex__child" *ngIf="group.contains('silo')">
                    <mat-label>{{ 'product.wizard.silo.silo' | translate }}</mat-label>
                    <mat-select formControlName="silo" [attr.data-test]="'product-silo__silo-name--' + index">
                      <ng-container *ngIf="getAvailableExactSilos(silos, group) as exactSilos; else noExactSilosAvailable">
                        <mat-option *ngFor="let silo of exactSilos" [value]="silo">
                          {{ silo | formatSiloTitle }}
                        </mat-option>
                      </ng-container>
                      <ng-template #noExactSilosAvailable>
                        <mat-option disabled>{{ 'product.wizard.silo.no-silos-available' | translate }}</mat-option>
                      </ng-template>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    class="product-silo__card-input mat-form-field__no-spacing flex__child"
                    *ngIf="group.contains('quantity')"
                  >
                    <mat-label>{{ 'product.wizard.silo.amount' | translate }}</mat-label>
                    <input matInput step="1" agrNumber formControlName="quantity" [attr.data-test]="'product-silo__silo-quantity--' + index" />
                    <span matSuffix *ngIf="orderingInformation">{{ orderingInformation?.orderUnit }}</span>
                  </mat-form-field>

                  <button mat-button (click)="removeEntry(index)" class="product-silo__card-button" data-test="product-silo__silo-delete">
                    <mat-icon>delete_outline</mat-icon>
                    <span>{{ 'product.wizard.silo.remove' | translate }}</span>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>

          <div class="spacing--margin-vertical">
            <button mat-button color="primary" (click)="addEntry()" data-test="product-silo__silo-add">
              <mat-icon>add</mat-icon>
              <span>{{ 'product.wizard.silo.add' | translate }}</span>
            </button>
            <ng-template [ngTemplateOutlet]="SiloManagementLink"></ng-template>
          </div>
        </div>
        <div *ngIf="this.exact.value === false" class="border-top spacing--margin-top">
          <div
            class="product-silo__description notification notification-description text--input-small"
            data-test="product-silo__less-than-quantity-description"
          >
            <mat-icon>information</mat-icon>
            {{ 'product.wizard.silo.silo-distribution-information-full' | translate }}
          </div>
          <mat-card
            appearance="outlined"
            class="spacing--margin-vertical spacing--margin-half-horizontal mat-elevation-z1"
            *ngIf="entries && getFormGroup(entries.controls[0]) as group"
          >
            <mat-card-header>
              <p class="text--bold spacing--margin-none-top spacing--margin-half-bottom">
                {{ 'product.wizard.silo.choose-full-and-rest' | translate }}
              </p>
            </mat-card-header>

            <mat-card-content>
              <div [class]="(isLtSm$ | async) ? 'flex--column' : 'flex--row flex--gutter flex--align-center'" [formGroup]="group">
                <mat-form-field appearance="outline" class="product-silo__card-input mat-form-field__no-spacing flex__child" *ngIf="group.contains('full')">
                  <mat-label>{{ 'product.wizard.silo.full' | translate }}</mat-label>
                  <mat-select formControlName="full" data-test="silo__silo-full">
                    <mat-option>-</mat-option>
                    <ng-container *ngIf="availableFullSilos$ | async as fullSilos; else noFullSilosAvailable">
                      <mat-option *ngFor="let silo of fullSilos" [value]="silo">
                        {{ silo | formatSiloTitle }}
                      </mat-option>
                    </ng-container>
                    <ng-template #noFullSilosAvailable>
                      <mat-option disabled>
                        {{ 'product.wizard.silo.no-silos-available' | translate }}
                      </mat-option>
                    </ng-template>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="product-silo__card-input mat-form-field__no-spacing flex__child" *ngIf="group.contains('rest')">
                  <mat-label>{{ 'product.wizard.silo.rest' | translate }}</mat-label>
                  <mat-select formControlName="rest" data-test="silo__silo-rest">
                    <mat-option>-</mat-option>
                    <ng-container *ngIf="availableRestSilos$ | async as restSilos; else noRestSilosAvailable">
                      <mat-option *ngFor="let silo of restSilos" [value]="silo">{{ silo | formatSiloTitle }}</mat-option>
                    </ng-container>
                    <ng-template #noRestSilosAvailable>
                      <mat-option disabled>
                        {{ 'product.wizard.silo.no-silos-available' | translate }}
                      </mat-option>
                    </ng-template>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
          <ng-template [ngTemplateOutlet]="SiloManagementLink"></ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="product-silo__loading flex--row flex--justify-center flex--align-center spacing--margin-vertical"
    data-test="product-silo__loading"
    *ngIf="(silosLoaded$ | async) !== true && (silosNotAvailable$ | async) !== true"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="(silosNotAvailable$ | async) === true">
    <div class="product-silo__warning notification notification-warning text--input-small" data-test="product-silo__no-silos-warning">
      <mat-icon>warning</mat-icon>
      {{ 'product.wizard.silo.error-no-silos' | translate }}
    </div>
  </ng-container>
</div>

<ng-template #SiloManagementLink>
  <a mat-button [href]="env.SHOP_URL + '/silos' + (sessionUrl$ | async)" class="text-color--primary">
    <mat-icon>create</mat-icon>
    <span>{{ 'product.wizard.silo.manage-silos' | translate }}</span>
  </a>
</ng-template>
